import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {NgxPaginationModule} from 'ngx-pagination'; // Pagination
import {Ng2OrderModule} from 'ng2-order-pipe'; // importing the module
import {FormsModule} from '@angular/forms';
import {HttpClientModule } from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ReactiveFormsModule} from '@angular/forms';
import {LeftnavComponent} from './web/leftnav/leftnav.component';
import {TopnavComponent} from './web/topnav/topnav.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import {OrderModule} from 'ngx-order-pipe';
import {PagenotfoundComponent} from './web/pagenotfound/pagenotfound.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import {
  BusinessEntityComponent
} from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity/business-entity.component';
import {
  BusinessEntityFarmProviderComponent
} from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity-farm-provider/business-entity-farm-provider.component';
import {
  BusinessEntityFarmsComponent
} from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity-farms/business-entity-farms.component';
import {
  BusinessEntityFarmSiteComponent
} from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-entity-farm-site/business-entity-farm-site.component';
import {AddFarmComponent} from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/add-farm/add-farm.component';
import {PersonsListComponent} from './web/leftnav/AdminPanel/TradingCommunity/People/persons-list.component';
import {
  BusinessFarmfpFarmFarmsiteComponent
} from './web/leftnav/AdminPanel/TradingCommunity/BusinessEntities/business-farmfp-farm-farmsite/business-farmfp-farm-farmsite.component';
import {BlubayDashboardComponent} from './web/leftnav/blubay-dashboard/blubay-dashboard.component';
import {CultureSummaryReportComponent} from './web/leftnav/Reports/Farm/CultureSummary/culture-summary-report.component';
import {LoginComponent} from './web/login/login.component';
import {PrivacyPolicyComponent} from './web/privacy-policy/privacy-policy.component';
import {ImagesDetailsComponent} from './web/leftnav/blubay-dashboard/images-details/images-details.component';
import {TermsofuseComponent} from './web/termsofuse/termsofuse.component';
import {PondsSummaryReportsComponent} from './web/leftnav/Reports/Farm/PondSummary/ponds-summary-reports.component';
import {CurrencyFormatPipe} from './currency-format.pipe';
import {AclSyncComponent} from './web/leftnav/AdminPanel/UserAccess/Sync/acl-sync.component';
import {SpeciesTypeComponent} from './web/leftnav/AdminPanel/Pond/SpeciesType/species-type.component';
import {CultureCategoryComponent} from './web/leftnav/AdminPanel/Pond/CultureCategories/culture-category.component';
import {SoilTypeComponent} from './web/leftnav/AdminPanel/Pond/SoilType/soil-type.component';
import {WaterTypeComponent} from './web/leftnav/AdminPanel/Pond/WaterType/water-type.component';
import {BarCodeComponent} from './web/leftnav/AdminPanel/AddBarcode/bar-code.component';
import {WaterQualityHistoryComponent} from './web/leftnav/History/WaterQuality/water-quality-history.component';
import {TotalAreaListComponent} from './web/leftnav/blubay-dashboard/total-area-list/total-area-list.component';
import {TotalStockingListComponent} from './web/leftnav/blubay-dashboard/total-stocking-list/total-stocking-list.component';
import {UomComponent} from './web/leftnav/AdminPanel/MaterialManagement/UOM/uom.component';
import {ItemTypesComponent} from './web/leftnav/AdminPanel/MaterialManagement/ItemType/item-types.component';
import {TransactionTypeComponent} from './web/leftnav/AdminPanel/MaterialManagement/TransactionType/transaction-type.component';
import {FeedComponent} from 'src/app/web/leftnav/Metrics/Farm/Feed/feed.component';
import {StockingDensityComponent} from './web/leftnav/Metrics/Farm/StockingDensity/stocking-density.component';
import {PondComponent} from './web/leftnav/Metrics/Farm/Pond/pond.component';
import {WaterQualityComponent} from './web/leftnav/Metrics/Farm/WaterQuality/water-quality.component';
import {GrowthComponent} from './web/leftnav/Metrics/Farm/Sampling/growth.component';
import {HarvestComponent} from './web/leftnav/Metrics/Farm/Harvest/harvest.component';
import {MaterialMovementRegisterComponent} from './web/leftnav/Reports/Farm/MaterialMovementRegister/material-movement-register.component';
import {TransactionRegisterComponent} from './web/leftnav/Reports/Farm/TransactionsRegister/transaction-register.component';
import {RoutesComponent} from './web/leftnav/AdminPanel/UserAccess/Routes/routes.component';
// import { InventoryTransactionComponent } from './transactions/inventory-transaction/inventory-transaction.component';
// import { PersonComponent } from './TradingCommunity/Persons/person/person.component';
import {FeatureComponent} from './web/leftnav/AdminPanel/UserAccess/Feature/feature.component';
import {ScreenComponent} from './web/leftnav/AdminPanel/UserAccess/Screen/screen.component';
import {FarmSpendAnalyzerComponent} from './web/leftnav/MaterialManagement/FarmSpendAnalysis/farm-spend-analyzer.component';
import {TotalPondsListComponent} from './web/leftnav/blubay-dashboard/total-ponds-list/total-ponds-list.component';
import {SMEDashboardComponent} from '../app/web/sme-dashboard/sme-dashboard.component';
// import {IvyCarouselModule} from 'angular-responsive-carousel';
import {ToastNoAnimationModule, ToastrModule} from 'ngx-toastr';
import {environment} from 'src/environments/environment';
// import {MessagingService} from './messaging.service';
import {AsyncPipe, DatePipe} from '@angular/common';
import {VendorMasterComponent} from './web/leftnav/AdminPanel/MaterialManagement/VendorMaster/vendor-master.component';
import {BatchTransactionComponent} from './web/leftnav/MaterialManagement/BatchTransactions/batch-transaction/batch-transaction.component';
import {
  BatchTransactionsComponent
} from './web/leftnav/MaterialManagement/BatchTransactions/batch-transactions/batch-transactions.component';
import {
  BatchEntryDashboardComponent
} from './web/leftnav/MaterialManagement/BatchTransactions/batch-entry-dashboard/batch-entry-dashboard.component';
import {AddtreatmentComponent} from './web/leftnav/MaterialManagement/BatchTransactions/addtreatment/addtreatment.component';
import {TreatmentsComponent} from './web/leftnav/MaterialManagement/BatchTransactions/treatments/treatments.component';
import {
  MultiLinePurchaseComponent
} from './web/leftnav/MaterialManagement/BatchTransactions/MultiLinePurchase/multi-line-purchase.component';
import {PondTracebilityComponent} from './web/leftnav/Reports/Farm/TraceabilityReport/pond-tracebility.component';
import {DaySummaryComponent} from './web/leftnav/Reports/Farm/DaySummary/day-summary.component';
import {
  ProjectedFeedGraphComponent
} from './web/leftnav/Charts/Trend Analysis/ActualVsProjected/projected-feed-graph/projected-feed-graph.component';
import {TankshiftComponent} from './web/leftnav/AdminPanel/tankshift/tankshift.component';
import {PaymentTransactionComponent} from './web/leftnav/MaterialManagement/payment-transaction/payment-transaction.component';
import {MaterialTransactionComponent} from './web/leftnav/MaterialManagement/material-transaction/material-transaction.component';
import {
  PaymentTransactionRegisterComponent
} from './web/leftnav/Reports/Farm/payment-transaction-register/payment-transaction-register.component';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';
import {AnalyticsComponent} from './web/leftnav/Charts/analytics/analytics.component';
import {BusinessCategoryComponent} from './web/leftnav/AdminPanel/UserAccess/business-category/business-category.component';
import {PersonRoleComponent} from './web/leftnav/AdminPanel/UserAccess/person-role/person-role.component';
import {BusinessTypeComponent} from './web/leftnav/AdminPanel/UserAccess/business-type/business-type.component';
import {ProductsComponent} from './web/leftnav/AdminPanel/MaterialManagement/products/products.component';
import {ShapesComponent} from './web/leftnav/AdminPanel/MaterialManagement/shapes/shapes.component';
import {ActivityTrackerComponent} from './web/leftnav/Reports/Staff/activity-tracker/activity-tracker.component';
import {ExcelService} from './services/excelService';
import { GoogleMapsModule } from '@angular/google-maps';
import {PriceTickerUploadComponent} from './web/leftnav/price-ticker-upload/price-ticker-upload.component';
import {OrdersComponent} from './web/leftnav/AdminPanel/Orders/orders.component';
import {HomeComponent} from './home/home.component';
import {ForgotPasswordStep1Component} from './web/forgot-password-step1/forgot-password-step1.component';
import {ForgotPasswordStep2Component} from './web/forgot-password-step2/forgot-password-step2.component';
import {ResetpasswordComponent} from './web/resetpassword/resetpassword.component';
import {
  BatchWaterQualityComponent
} from './web/leftnav/MaterialManagement/BatchTransactions/batch-water-quality/batch-water-quality.component';
import {
  BatchWaterQualityViewComponent
} from './web/leftnav/MaterialManagement/BatchTransactions/batch-water-quality-view/batch-water-quality-view.component';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import {QuickRegistrationComponent} from './web/leftnav/AdminPanel/TradingCommunity/quick-registration/quick-registration.component';
import {WeeklyGrowthReportComponent} from './web/leftnav/Reports/Farm/weeklyGrowth/weekly-growth-report/weekly-growth-report.component';
import { MultilineExpenseComponent } from './web/leftnav/MaterialManagement/BatchTransactions/multiline-expense/multiline-expense.component';
import { AccountClosureComponent } from './web/leftnav/AdminPanel/TradingCommunity/Account-closure/account-closure/account-closure.component';
import { AccountClosureDialogPopupsComponent } from './web/leftnav/AdminPanel/AccountClosureDialogPopups/account-closure-dialog-popups/account-closure-dialog-popups.component';
import { CultureEstimatorComponent } from './web/leftnav/Reports/Farm/cultureEstimator/culture-estimator/culture-estimator.component';
import { FirebaseNotificationsMessagingService } from './services/FirebaseMessaging.service';
import { initializeApp } from "firebase/app";
import { PreviousRouteService } from './services/previousRouteService';
import { ActivityTrackerCopyComponent } from './web/leftnav/Reports/Staff/activity-tracker-copy/activity-tracker-copy.component';
import { DateRangePopupComponent } from './web/date-range-popup/date-range-popup.component';
import { DashboardCopyComponent } from './web/leftnav/providerTechnican/dashboard-copy/dashboard-copy.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatNativeDateModule, MatOptionModule} from "@angular/material/core";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatDatepickerModule} from "@angular/material/datepicker";
import { MatRadioModule } from '@angular/material/radio';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CUSTOM_DATE_FORMATS } from './Utils/date-format';
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DashboardComponent } from './web/admin-dashboard/dashboard.component';
import { ActivitiesListComponent } from './web/leftnav/AdminPanel/MaterialManagement/activities-list/activities-list.component';
import { BroodBreedersComponent } from './web/leftnav/AdminPanel/MaterialManagement/brood-breeders/brood-breeders.component';
import { BroodLinesComponent } from './web/leftnav/AdminPanel/MaterialManagement/brood-lines/brood-lines.component';
import { ObservationTypesComponent } from './web/leftnav/AdminPanel/MaterialManagement/observation-types/observation-types.component';
import { PondTypesComponent } from './web/leftnav/AdminPanel/MaterialManagement/pond-types/pond-types.component';
import { PondUsagesComponent } from './web/leftnav/AdminPanel/MaterialManagement/pond-usages/pond-usages.component';
import { TreatmentTypesComponent } from './web/leftnav/AdminPanel/MaterialManagement/treatment-types/treatment-types.component';
import { SensorComponent } from './web/leftnav/AdminPanel/Hardware/Sensor/sensor.component';
import { SensorTypeComponent } from './web/leftnav/AdminPanel/Hardware/SensorType/sensor-type.component';
import { DeviceModelComponent } from './web/leftnav/AdminPanel/Hardware/DeviceModel/device-model.component';
import { QPTypeComponent } from './web/leftnav/AdminPanel/Test Configurations/QualityParametersType/qp-type.component';
import { QpRangesComponent } from './web/leftnav/AdminPanel/Test Configurations/QPRanges/qp-ranges.component';
import { QueryParamsComponent } from './web/leftnav/AdminPanel/Test Configurations/QualityParameters/query-params.component';
import { TestCategoryComponent } from './web/leftnav/AdminPanel/Test Configurations/TestCategories/test-category.component';
import { SubscriptionsComponent } from './web/leftnav/Reports/subscriptions/subscriptions.component';
import { BluEyeComponent } from './web/bluEye/blu-eye.component';
import { MarketConnectComponent } from './web/leftnav/market-connect/market-connect.component';

initializeApp(environment.firebase);

/**
 * @module AppModule
 * @description
 * The root module of the AquaCloud application. It serves as the central hub for declaring components,
 * importing modules, and providing global services.
 *
 * **Key Responsibilities:**
 * 1. **Application Bootstrap**: Bootstraps the `AppComponent` to launch the application.
 * 2. **Component Declaration**: Registers all application components, including:
 *    - **Admin Panel**: User access, trading community, hardware configuration.
 *    - **Dashboards**: Main dashboard, SME dashboard, provider dashboards.
 *    - **Reports**: Farm summary, water quality, weekly growth, activity trackers.
 *    - **Material Management**: Transactions, batch management, vendor masters.
 * 3. **Module Integration**: Imports core Angular modules and third-party libraries:
 *    - **UI Frameworks**: Angular Material and ngx-bootstrap.
 *    - **Utilities**: Toastr for notifications, Pagination, Ordering.
 *    - **Maps**: Google Maps integration.
 * 4. **Global Configuration**:
 *    - Configures `ToastrModule` with global settings (timeout, progress bar).
 *    - Configures `BsDatepickerModule`.
 *    - Sets up Material Datepicker with Moment.js adapter and custom formats.
 *
 * **Global Services (Providers):**
 * - `FirebaseNotificationsMessagingService`: Manages push notifications.
 * - `ExcelService`: Handles Excel export functionality.
 * - `PreviousRouteService`: Tracks navigation history.
 * - `DatePipe`, `AsyncPipe`: Global pipes.
 *
 * **Initialization Logic:**
 * - Initializes Firebase app with environment configuration.
 * - Dynamically loads Google Maps API script in the constructor.
 *
 * @author AquaCloud Development Team
 * @version 1.0.0
 */
@NgModule({
  declarations: [
    AppComponent,
    LeftnavComponent,
    TopnavComponent,
    PondComponent,
    FeedComponent,
    StockingDensityComponent,
    HarvestComponent,
    GrowthComponent,
    WaterQualityComponent,
    PagenotfoundComponent,
    BusinessEntityComponent,
    BusinessEntityFarmProviderComponent,
    BusinessEntityFarmsComponent,
    BusinessEntityFarmSiteComponent,
    AddFarmComponent,
    PersonsListComponent,
    BusinessFarmfpFarmFarmsiteComponent,
    BlubayDashboardComponent,
    TotalPondsListComponent,
    TotalStockingListComponent,
    TotalAreaListComponent,
    CultureSummaryReportComponent,
    LoginComponent,
    PrivacyPolicyComponent,
    ImagesDetailsComponent,
    TermsofuseComponent,
    PondsSummaryReportsComponent,
    MaterialMovementRegisterComponent,
    CurrencyFormatPipe,
    AclSyncComponent,
    SpeciesTypeComponent,
    CultureCategoryComponent,
    SoilTypeComponent,
    WaterTypeComponent,
    BarCodeComponent,
    WaterQualityHistoryComponent,
    UomComponent,
    ItemTypesComponent,
    TransactionTypeComponent,
    TransactionRegisterComponent,
    RoutesComponent,
    FeatureComponent,
    ScreenComponent,
    FarmSpendAnalyzerComponent,
    SMEDashboardComponent,
    VendorMasterComponent,
    BatchTransactionComponent,
    BatchTransactionsComponent,
    BatchEntryDashboardComponent,
    AddtreatmentComponent,
    TreatmentsComponent,
    MultiLinePurchaseComponent,
    PondTracebilityComponent,
    DaySummaryComponent,
    ProjectedFeedGraphComponent,
    TankshiftComponent,
    PaymentTransactionComponent,
    MaterialTransactionComponent,
    PaymentTransactionRegisterComponent,
    AnalyticsComponent,
    BusinessCategoryComponent,
    PersonRoleComponent,
    BusinessTypeComponent,
    ProductsComponent,
    ShapesComponent,
    ActivityTrackerComponent,    
    PriceTickerUploadComponent,
    OrdersComponent,
    HomeComponent,
    ForgotPasswordStep1Component,
    ForgotPasswordStep2Component,
    ResetpasswordComponent,
    BatchWaterQualityComponent,
    BatchWaterQualityViewComponent,
    QuickRegistrationComponent,
    WeeklyGrowthReportComponent,
    MultiLinePurchaseComponent,
    MultilineExpenseComponent,
    AccountClosureComponent,
    AccountClosureDialogPopupsComponent,
    CultureEstimatorComponent,
    ActivityTrackerCopyComponent,
    DateRangePopupComponent,
    DashboardCopyComponent,
    SubscriptionPlansComponent,
    BluEyeComponent,
    DashboardComponent,
    ActivitiesListComponent,
    BroodBreedersComponent,
    BroodLinesComponent,
    ObservationTypesComponent,
    PondTypesComponent,
    PondUsagesComponent,
    TreatmentTypesComponent,
    DeviceModelComponent,
    SensorComponent,
    SensorTypeComponent,
    QpRangesComponent,
    QPTypeComponent,
    QueryParamsComponent,
    TestCategoryComponent,
    SubscriptionsComponent,
    MarketConnectComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    // Ng2OrderModule,
    Ng2OrderModule,
    AutocompleteLibModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule,
    OrderModule,
    ReactiveFormsModule,
    CollapseModule,
    BsDropdownModule,
    TimepickerModule,
    ButtonsModule,
    // IvyCarouselModule
    // AngularDateTimePickerModule
    ToastrModule.forRoot({
      closeButton: true,
      timeOut: 2000, // 1 seconds
      progressBar: true,
    }), // ToastrModule added,
    ToastNoAnimationModule.forRoot(),
    GoogleMapsModule,
    NgxMaterialTimepickerModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatSlideToggleModule,
    ScrollingModule
  ],
  providers: [FirebaseNotificationsMessagingService, AsyncPipe, ExcelService, PreviousRouteService, DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  /**
   * @constructor
   * @description
   * Initializes the AppModule.
   * Triggers the loading of external scripts required for the application.
   */
  constructor() {
    this.loadGoogleMaps();
  }

  /**
   * @method loadGoogleMaps
   * @description
   * Dynamically appends the Google Maps JavaScript API script to the document head.
   * This is necessary for the `GoogleMapsModule` and related components (e.g., `MapDeviceComponent`) to function.
   *
   * **Implementation Details:**
   * - Creates a `<script>` element.
   * - Sets the `src` attribute with the API key.
   * - Sets `async` and `defer` for performance.
   * - Appends to `document.head`.
   *
   * @returns {void}
   * @side-effect Modifies the DOM by adding a script tag.
   */
  loadGoogleMaps() {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBrPSo5L3Y7IVgvKXMJFNPL66uwZp3zQdg`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
